import React from "react";

function WoodenIrfan() {
  return (
    <>
      <iframe src="https://my.spline.design/woodensirfan-775dac2c0ace3071194f404453a3200c/" allow="full"></iframe>
    </>
  );
}

export default WoodenIrfan;
